import EscalationProfile from './EscalationProfile';

export { EscalationProfile };
export default EscalationProfile;
